<template>
   <div class="grey-wrapper-2 cutomer-success">
      <div class="container container-1200 info-wrapper">
         <div class="row ">
            <div class="col-md-12 col-lg-12 extheader text-center">
               <h2 v-if="config.header">{{ config.header }}</h2>
            </div>
         </div>
         <div class="pb-5">
            <div class="container container-1200">
               <div class="row pt-4 row-eq-height justify-content-center">
                  <div class="col-12">
                     <div class="card-deck card-deck-special">
                        <div
                           v-for="(item, index) in config.body"
                           :key="index"
                           class="card card-item-customer"
                        >
                           <router-link :to="item.url" active-class="active" class="card-content">
                              <div
                                 class="card-header d-flex justify-content-center align-items-center"
                              >
                                 <div class="image-container">
                                    <img
                                       :src="item.rasterSource.file.url"
                                       :alt="item.rasterSource.description"
                                       class="card-img-top img img-fluid"
                                    />
                                 </div>
                              </div>
                              <div class="card-body ">
                                 <p class="card-text">{{ `${shorten(item.header, 80)}` }}</p>
                              </div>
                           </router-link>
                        </div>
                     </div>
                  </div>
               </div>
            </div>
         </div>
      </div>
   </div>
</template>

<script>
export default {
   name: 'SuccessStoriesCustomer',
   props: {
      config: {
         type: Object,
         default: () => null,
      },
      gradclass: {
         type: String,
         default: '',
      },
   },
   data: () => ({
      totalCards: 3,
   }),
   methods: {
      loadMoreAction() {
         this.totalCards = this.config.body.length;
      },
      shorten(text, maxLength) {
         let ret = text;
         if (ret.length > maxLength) {
            ret = `${ret.substr(0, maxLength - 3)}…`;
         }
         return ret;
      },
   },
};
</script>

<style lang="scss">
.cutomer-success {
   padding-top: 53px;
   .underline {
      border: 1px solid #efefef;
   }
   img {
      width: auto;
   }
   .card-footer {
      position: relative;
      &::after {
         content: '';
         position: absolute;
         top: 0;
         left: 0;
         width: 100%;
         height: 100%;
         background: linear-gradient(to bottom, rgba(255, 255, 255, 0), rgba(255, 255, 255, 1));
      }
   }

   // .card-item-customer {
   //    // flex: 0 0 30%;
   //    flex: 0 0 29%;
   //    @media (min-width: 769px) {
   //       flex: 0 0 30%;
   //    }
   //    margin-bottom: 20px;

   //    .card-header {
   //       min-height: 156px;
   //    }
   // }

   // .card-deck {
   //    justify-content: left;
   //    padding-left: 1%;
   //    .card {
   //       a {
   //          text-decoration: none;
   //          color: #313131;
   //       }
   //    }
   // }
}

.subheading {
   font-size: 16px;
   line-height: 20px;
   a {
      font-weight: 600;
   }
}
.first-eq-card {
   margin-bottom: 20px;
}

@media (min-width: 799px) {
   .first-eq-card {
      margin-bottom: 0px;
   }
}

.card-deck-special {
   margin: 15px -15px;

   .card {
      background: none;
      border-radius: 0;
      margin: 0;
      padding: 10px 15px 20px;

      flex: 0 0 auto;
      min-width: 100%;
      max-width: 100%;

      @media (min-width: 567px) {
         flex: 0 0 auto;
         min-width: 50%;
         max-width: 50%;
      }

      @media (min-width: 1200px) {
         flex: 0 0 auto;
         min-width: 33.33%;
         max-width: 33.33%;
      }
      // @media (min-width: 1440px) {
      //    flex: 0 0 auto;
      //    min-width: 25%;
      //    max-width: 25%;
      // }
      .card-header {
         min-height: 156px;
      }

      .card-text {
         color: #313131;
         font-size: 16px;
         letter-spacing: 0.23px;
         line-height: 24px;
      }

      .card-title {
         font-size: 16px;
         letter-spacing: 0.23px;
         line-height: 20px;
         color: #212344;
      }

      .card-body {
         p:last-child {
            margin-bottom: 0;
         }
      }

      .card-content {
         height: 100%;
         background: #fff;
         border-radius: 5px;
         box-shadow: 0 6px 14px 0 rgba(33, 35, 68, 0.05) !important;
      }

      a.card-content {
         transition: all 0.2s ease;
         text-decoration: none;
         &:hover {
            transform: translateY(-4px);
            transition: all 0.2s ease;
         }
      }

      // .card-img-top {
      //    height: 200px;
      // }
   }
}
</style>
